import { toHumanErrorMessage } from "@/lib/extensions/httpErrorExtension";

/**
 * The sentence a failed group call is shown with: the backend's own, as it is. A 5xx answers
 * ProblemDetails with no `message`, which can leave it empty, so there is a plain fallback.
 */
export function refusalMessage(error: unknown): string {
  return (
    toHumanErrorMessage(error) ||
    "The server did not say why. Try again in a moment."
  );
}

/**
 * A refusal that names one of the events the curator picked (or the current event) gets that
 * event's label after it, so two same-named picks can be told apart. The message is otherwise as the
 * backend said it. The id must be a whole word of the message: `e1` is not in `Event e10`.
 */
export function refusalNamingEvent(
  message: string,
  events: { id: string; label: string }[],
): string {
  const words = new Set(message.split(/[^A-Za-z0-9_-]+/));
  const named = events.find((event) => event.label && words.has(event.id));
  return named ? `${message} (${named.label})` : message;
}
